import React, { useState } from 'react';
import InTransactionForm from './InTransactionForm';
import OutTransactionForm from './OutTransactionForm';

const TransactionTabs: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'in' | 'out'>('out');

  const tabs = [
    { id: 'in', label: 'In Transaction', icon: '↓' },
    { id: 'out', label: 'Out Transaction', icon: '↑' }
  ];

  return (
    <div className="space-y-6">
      {/* Tab Navigation */}
      <div className="border-b border-gray-200">
        <nav className="-mb-px flex space-x-8">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id as 'in' | 'out')}
              className={`
                whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm flex items-center space-x-2
                ${activeTab === tab.id
                  ? 'border-ocean-500 text-ocean-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }
              `}
            >
              <span className="text-lg">{tab.icon}</span>
              <span>{tab.label}</span>
            </button>
          ))}
        </nav>
      </div>

      {/* Tab Content */}
      <div className="mt-6">
        {activeTab === 'in' && <InTransactionForm />}
        {activeTab === 'out' && <OutTransactionForm />}
      </div>
    </div>
  );
};

export default TransactionTabs; 